import Ajax from "Utils/ajax";
export const addUpdateDocumentCategory = (data) => Ajax.post('setting/addUpdateDocumentCategory',data);
export const getDocumentCategoryList = (data) => Ajax.post('setting/getDocumentCategoryList',data);
export const getDocumentClass = (data) => Ajax.post('setting/getDocumentClass',data);
export const deleteDocumentCategory = (data) => Ajax.post('setting/deleteDocumentCategory',data);